import { useEffect, useState } from "react";
import { Tooltip, Menu } from "antd";
import { NavLink, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

import { TStoreData } from "@/interface";
import store from "@/store";

import { useLogUtil } from "@/util/log";

const SubMenu = withRouter((props) => {
    const { history } = props;
    const [selectedKeys, setSelectedKeys] = useState("");
    const [openKeys, setOpenKeys] = useState<any>([]);
    const { log } = useLogUtil();
    const storeState = useSelector((data: TStoreData) => {
        return {
            subMenuList: data?.subMenuList || [],
            childMenu: data?.childMenu || {},
            customRecord: data?.customRecord,
            flowAndOtherActive: data?.flowAndOtherActive,
        };
    });

    const { subMenuList, childMenu } = storeState;

    useEffect(() => {
        /* TODO: 初始化判断跳转404 */
        if (childMenu && Object.keys(childMenu).length) {
            subMenuList.forEach((item) => {
                getOpenKey(item);
            });
            setSelectedKeys(childMenu.key);
        }
    }, [childMenu]);

    const getOpenKey = (menu: any) => {
        for (let i = 0; i < menu?.children?.length; i++) {
            if (menu?.children[i] === childMenu) {
                setOpenKeys((openKeys: any) => {
                    return [...openKeys, menu.key];
                });
            }
            if (menu?.children[i]?.children)
                getOpenKey(menu?.children[i].children);
        }
    };
    const changeMenu = (info: any) => {
        /* TODO:跳转连接拼接 */
        // console.log("gyp click", info);
        const { item } = info;

        log({
            eventId: "Second_Level_Menu_Click",
            eventParams: {
                erp: sessionStorage.getItem("erp"),
                tenantCode: sessionStorage.getItem("tenantCode"),
                title: item.props.title,
                url: item.props.url,
            },
        });
        history.push(
            item.props.url?.indexOf("http") !== -1
                ? `/iframe-view/${encodeURIComponent(item.props.url)}`
                : item.props.url
        );
    };

    const SubMenuCom = () => {
        return (
            <div className="lr-layout-left-side-menu">
                <Menu
                    onSelect={changeMenu}
                    inlineIndent={16}
                    defaultSelectedKeys={[selectedKeys]}
                    defaultOpenKeys={openKeys}
                    mode="inline"
                    items={subMenuList}
                />
            </div>
        );
    };

    return subMenuList?.length ? <SubMenuCom /> : null;
});

export default SubMenu;
